import { Injectable, Signal, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private _pendingCount = 0;
  private _loading$ = signal<boolean>(false);
  private _message$ = signal<string>('');
  private _suppressed$ = signal<boolean>(false);

  get loading$(): Signal<boolean> {
    return this._loading$.asReadonly();
  }

  // Lets a component that shows its own spinner (e.g. inside a dialog) hide the global one.
  get suppressed$(): Signal<boolean> {
    return this._suppressed$.asReadonly();
  }

  setSuppressed(value: boolean): void {
    this._suppressed$.set(value);
  }

  get message$(): Signal<string> {
    return this._message$.asReadonly();
  }

  startLoading(): void {
    this._pendingCount++;
    this._loading$.set(true);
    this._message$.set('');
  }

  stopLoading(): void {
    this._pendingCount = Math.max(0, this._pendingCount - 1);
    if (this._pendingCount === 0) {
      this._loading$.set(false);
      this._message$.set('');
    }
  }

  show(message?: string): void {
    this._pendingCount++;
    this._loading$.set(true);
    this._message$.set(message || '');
  }

  hide(): void {
    this._pendingCount = Math.max(0, this._pendingCount - 1);
    if (this._pendingCount === 0) {
      this._loading$.set(false);
      this._message$.set('');
    }
  }
}
